import React from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppWidget = () => {
  return (
    <motion.a
      href="https://wa.me/917010755885?text=Hi%20ISAAC%20Logistics%2C%20I%20would%20like%20to%20inquire%20about%20your%20shipping%20and%20logistics%20services."
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0.5, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      whileHover={{ scale: 1.15 }}
      whileTap={{ scale: 0.9 }}
      transition={{ duration: 0.3 }}
      style={{
        position: 'fixed',
        bottom: '9.8rem', // Placed directly above the BackToTop button
        right: '2rem',
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
        color: '#fff',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        boxShadow: '0 8px 24px rgba(37, 211, 102, 0.45)',
        textDecoration: 'none'
      }}
      aria-label="Contact us on WhatsApp"
    >
      <FaWhatsapp size={26} />
    </motion.a>
  );
};

export default WhatsAppWidget;
